import { render, staticRenderFns } from "./EditFormStaticText.vue?vue&type=template&id=4cac9840"
import script from "./EditFormStaticText.vue?vue&type=script&lang=js"
export * from "./EditFormStaticText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports